import { createSlice } from '@reduxjs/toolkit';

import type { PayloadAction } from '@reduxjs/toolkit';
import type { IVoiceScriptState } from '@/store/types';

export const initialState: IVoiceScriptState = {
  permission: {
    prompt: false,
    granted: false,
  },
  configuration: {
    start: false,
    status: false,
  },
  question: null,
  applicationId: 0,
  questionId: 0,
  questionBlob: null,
};

export const voiceScriptSlice = createSlice({
  name: 'voiceScriptSlice',
  initialState,
  reducers: {
    setPermissionPrompt(state: IVoiceScriptState, action: PayloadAction<boolean>) {
      state.permission.prompt = action.payload;
    },
    setPermissionGranted(state: IVoiceScriptState, action: PayloadAction<boolean | null>) {
      state.permission.granted = action.payload;
    },
    setConfigurationStart(state: IVoiceScriptState, action: PayloadAction<boolean>) {
      state.configuration.start = action.payload;
    },
    setConfigurationStatus(state: IVoiceScriptState, action: PayloadAction<boolean>) {
      state.configuration.status = action.payload;
    },
    setQuestionId(state: IVoiceScriptState, action: PayloadAction<number>) {
      state.questionId = action.payload;
    },
    setApplicationId(state: IVoiceScriptState, action: PayloadAction<number>) {
      state.applicationId = action.payload;
    },
    setQuestionBlob(state: IVoiceScriptState, action: PayloadAction<Blob>) {
      state.questionBlob = action.payload;
    },
  },
});

export const {
  setPermissionPrompt,
  setPermissionGranted,
  setConfigurationStart,
  setConfigurationStatus,
  setApplicationId,
  setQuestionId,
  setQuestionBlob,
} = voiceScriptSlice.actions;

export default voiceScriptSlice.reducer;
